// extracted by mini-css-extract-plugin
module.exports = {"item":"simpleMenu_item__2X9Us","downloadIcon":"simpleMenu_downloadIcon__3b_BJ","downloadIconText":"simpleMenu_downloadIconText__1q_dT"};